document.addEventListener('DOMContentLoaded', function () {
    var x = $('.rep-article-imgbox>a>img').height();
    $('.rep-article-item').css('height', x + 'px');  // 改为 min-height

    var y = $('.rep-article-item03').outerHeight(true) * 3;
    $('.product-blogbox03 .rep-article-set').css('height', y + 'px');  // 改为 min-height

    $(window).resize(function () {
        x = $('.rep-article-imgbox>a>img').height();
        $('.rep-article-item').css('height', x + 'px');  // 改为 min-height
        
        y = $('.rep-article-item03').outerHeight(true) * 3;
        $('.product-blogbox03 .rep-article-set').css('height', y + 'px');  // 改为 min-height
    });
    // const frequentlyObserver = new MutationObserver(function (mutationsList, observer) {
    //   if ($('.cbb-frequently-bought-container').length > 0) {
    //     $('.product-bacontainer .product-blogbox').before($('.cbb-frequently-bought-container'));
    //   }
    // });
    // frequentlyObserver.observe(document.querySelector('product-info'), {
    //   attributes: true,
    //   childList: true,
    //   subtree: true,
    // });
});